import { render, staticRenderFns } from "./EWMerchantRegistrationApprovedForm.vue?vue&type=template&id=00db0624&"
import script from "./EWMerchantRegistrationApprovedForm.vue?vue&type=script&lang=js&"
export * from "./EWMerchantRegistrationApprovedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports